import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { Dashboard } from './components/Dashboard';
import { Onboarding } from './components/Onboarding';
import { SharedCountdown } from './components/SharedCountdown';
import { PaymentSuccess } from './components/PaymentSuccess';
import { AuthPage } from './pages/AuthPage';
import { PricingPage } from './pages/PricingPage';
import { SuccessPage } from './pages/SuccessPage';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';

function App() {
  const { user, loading } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showCountdownModal, setShowCountdownModal] = useState(false);

  useEffect(() => {
    if (user) {
      const onboardingCompleted = user.user_metadata?.onboarding_completed;
      if (!onboardingCompleted) {
        setShowOnboarding(true);
      }
    }
  }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a3e54] flex items-center justify-center">
        <div className="text-[#feeddd] animate-pulse font-playfair text-2xl">Countr...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/share/:shareId" element={<SharedCountdown />} />
        
        {/* Protected Routes */}
        <Route 
          path="/payment-success" 
          element={user ? <PaymentSuccess /> : <Navigate to="/" replace />} 
        />
        <Route 
          path="/pricing" 
          element={user ? <PricingPage /> : <Navigate to="/" replace />} 
        />
        <Route 
          path="/success" 
          element={user ? <SuccessPage /> : <Navigate to="/" replace />} 
        />
        
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* Entry Point */}
        <Route 
          path="*" 
          element={user ? (
            <>
              <Dashboard 
                openCreateModal={showCountdownModal} 
                onModalStateChange={(isOpen) => setShowCountdownModal(isOpen)} 
              />
              {showOnboarding && (
                <Onboarding 
                  onComplete={() => setShowOnboarding(false)} 
                  onCreateFirstCountdown={() => setShowCountdownModal(true)} 
                />
              )}
            </>
          ) : (
            <AuthPage />
          )} 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;